var I = Object.defineProperty;
var r = Object.getOwnPropertySymbols;
var f = Object.prototype.hasOwnProperty, s = Object.prototype.propertyIsEnumerable;
var c = (t, e, o) => e in t ? I(t, e, { enumerable: !0, configurable: !0, writable: !0, value: o }) : t[e] = o, i = (t, e) => {
  for (var o in e || (e = {}))
    f.call(e, o) && c(t, o, e[o]);
  if (r)
    for (var o of r(e))
      s.call(e, o) && c(t, o, e[o]);
  return t;
};
var l = (t, e) => {
  var o = {};
  for (var n in t)
    f.call(t, n) && e.indexOf(n) < 0 && (o[n] = t[n]);
  if (t != null && r)
    for (var n of r(t))
      e.indexOf(n) < 0 && s.call(t, n) && (o[n] = t[n]);
  return o;
};
import p, { forwardRef as R } from "react";
import g from "../../atoms/Button/Button.js";
const w = R(function(x, B) {
  var a = x, { icon: e, children: o, testId: n = "fs-icon-button", "aria-label": b, size: d = "regular", variant: u } = a, m = l(a, ["icon", "children", "testId", "aria-label", "size", "variant"]);
  return p.createElement(g, i({ ref: B, "data-fs-button": !0, "data-fs-icon-button": !0, variant: u != null ? u : "tertiary", icon: e, "aria-label": b, testId: n, size: d }, m), o);
}), $ = w;
export {
  $ as default
};
